import * as actionTypes from "./actionTypes";

export const supportRequestStart = (pageLimit) => {
  return {
    type: actionTypes.SUPPORT_REQUEST_START,
    pageLimit,
  };
};
export const supportRequestLoading = () => {
  return {
    type: actionTypes.SUPPORT_REQUEST_LOADING,
  };
};
export const createSupportRequest = (supportData) => {
  return {
    type: actionTypes.CREATE_SUPPORT_REQUEST,
    supportData,
  };
};

export const createSupportRequestSuccess = (response) => {
  return {
    type: actionTypes.CREATE_SUPPORT_REQUEST_SUCCESS,
    response,
  };
};

export const createSupportRequestFail = (error) => {
  return {
    type: actionTypes.CREATE_SUPPORT_REQUEST_FAIL,
    error,
  };
};

export const getSupportRequests = (pageLimit) => {
  return {
    type: actionTypes.GET_SUPPORT_REQUESTS,
    pageLimit,
  };
};

export const getSupportRequestsSuccess = (response) => {
  return {
    type: actionTypes.GET_SUPPOR_REQUESTS_SUCCESS,
    response,
  };
};

export const getSupportRequestsFail = (error) => {
  return {
    type: actionTypes.GET_SUPPORT_REQUESTS_FAIL,
    error,
  };
};
